// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"E1-z","displaySixCardTiles":"F1-z"};